import FeedbackConstants from '../constants/FeedbackConstants';
import FeedbackApi from '../api/FeedbackApi';
import composeSuccessMessaging from '../helpers/messaging/composeSuccessMessaging';

export function collapseFeedbackBox() {
  return {
    type: FeedbackConstants.COLLAPSE_FEEDBACK
  };
}

export function expandFeedbackBox() {
  return {
    type: FeedbackConstants.EXPAND_FEEDBACK
  };
}

export function updateCategory(category) {
  return {
    type: FeedbackConstants.UPDATE_CATEGORY,
    payload: category
  };
}

export function submitFeedback(feedback) {
  return {
    types: [
      FeedbackConstants.SUBMIT_FEEDBACK_REQUEST,
      FeedbackConstants.SUBMIT_FEEDBACK_SUCCESS,
      FeedbackConstants.SUBMIT_FEEDBACK_FAILURE
    ],
    apiRequest: (state, apiClient) => FeedbackApi.submitFeedback(feedback, apiClient),
    apiSuccess: () => ({
      messaging: composeSuccessMessaging('userFeedback', 'message_feedback_confirmed')
    })
  };
}


export default {
  collapseFeedbackBox,
  expandFeedbackBox,
  updateCategory,
  submitFeedback
};




// WEBPACK FOOTER //
// ./app/actions/FeedbackActions.js